module.exports = __webpack_public_path__ + "img/grandtexte-bottom-bg.29f769d.svg";